export const installationStates = {
    HEALTHY: 'HEALTHY',
    UNHEALTHY: 'UNHEALTHY',
    ERRORED: 'ERRORED',
    CONNECTION_REQUIRED: 'CONNECTION_REQUIRED',
};
